module.exports = __webpack_public_path__ + "static/huni-fd192d740633d4ff2b7fa44033d57895.png";